<template>
  <v-data-table
    :headers="headers"
    :items="teams"
    sort-by="model"
    class="elevation-1 dark-last-row"
    hide-default-footer
    :loading="loading"
    items-per-page="500"
    mobile-breakpoint="0"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#003a6f"
      >
        <v-toolbar-title class="white--text">Teams</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialogPhase"
          max-width="500px"
          scrollable
        >
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">Edit Phase</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row"> 
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Job</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Job" rules="required">
                            <v-select
                                v-model="editedItem.job"
                                :items="jobs"
                                item-text="customer"
                                item-value="id"
                                label="Job"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                                return-object
                            ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.job.id">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Phase</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Phase" rules="required">
                              <v-select
                                  v-model="editedItem.job.phase"
                                  :items="editedItem.job.phases"
                                  item-text="title"
                                  item-value="id"
                                  label="Phase"
                                  :error-messages="errors"
                                  required
                                  solo
                                  flat
                                  dark
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.job.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu
                                v-model="menus"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedStartDateFormatted"
                                    label="Start Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    flat
                                    dark
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="editedItem.job.start_date"
                                @input="menus = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.job.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menue"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedEndDateFormatted"
                                  label="End Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedItem.job.end_date"
                              @input="menue = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedItem.job.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                              <v-select
                                  v-model="editedItem.job.status"
                                  :items="statuses"
                                  item-text="label"
                                  item-value="value"
                                  label="Status"
                                  :error-messages="errors"
                                  required
                                  solo
                                  flat
                                  dark
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="closePhase"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="savePhase"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Title</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Title" rules="required">
                              <v-text-field
                                v-model="editedItem.title"
                                label="Title"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Team Category" rules="required">
                            <v-select
                                v-model="editedItem.category"
                                :items="categories"
                                item-text="label"
                                item-value="value"
                                label="Team Category"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                            ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-row align="center" class="ma-0">
        <v-date-picker
          v-model="picker"
          flat
          full-width
          class="dpick"
          no-title
        ></v-date-picker>
      </v-row>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getEquipment"
        tile
        :loading="loading"
      >
        No Items Found. Click Here to Refresh!
      </v-btn>
    </template>
    <template v-slot:item.phase="{ item }">
        <a href="#" @click.prevent="editPhase(item)" v-if="item.job.title">{{ getPhaseTitle(item) }}</a>
    </template>
      <template v-slot:item.customer="{ item }">
        <router-link :to="`/job/main/${item.job.id}`"
        v-if="item.job.id"
        >
            {{ item.job.customer }}
        </router-link>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            dialogPhase: false,
            menu: false,
            picker: new Date().toISOString().substr(0, 10),
            headers: [
                { text: 'Crew', value: 'title', sortable: false },
                { text: 'Phase', value: 'phase', sortable: false },
                { text: 'Customer', value: 'customer', sortable: false },
            ],
            teams: [],
            jobs: [],
            phases: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                title: '',
                category: '',
                job: {
                  id: '',
                  phase: '',
                  customer: '',
                  title: '',
                  start_date: new Date().toISOString().substr(0, 10),
                  end_date: new Date().toISOString().substr(0, 10),
                  status: 'in_progress'
                }
            },
            defaultItem: {
                id: '',
                title: '',
                category: '',  
                job: {
                  id: '',
                  phase: '',
                  customer: '',
                  title: '',
                  start_date: new Date().toISOString().substr(0, 10),
                  end_date: new Date().toISOString().substr(0, 10),
                  status: 'in_progress'
                }             
            },
            categories: [
              { label: 'Dig Team', value: 1 },
              { label: 'Concrete Crew', value: 2 },
              { label: 'Liner Crew', value: 3 },
              { label: 'Grade Crew', value: 4 },
              { label: 'Finish up Crew', value: 5 },
            ],
            expanded: [],
            statuses: [
                { label: 'Completed', value: 'completed' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Cancelled', value: 'cancelled' },
            ],
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Team' : 'Edit Team'
            },
            computedStartDateFormatted () {
              if(this.editedItem.job)
                return this.formatDate(this.editedItem.job.start_date)
              else 
                return ''
            },
            computedEndDateFormatted () {
              if(this.editedItem.job)
                return this.formatDate(this.editedItem.job.end_date)
              else
                return ''
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            'editedItem.phase': function(newVal) {
              let phase = this.jobs.filter(p => {
                return p.id == newVal
              })

              this.editedItem.job = phase[0]
            },
            picker () {
              this.getTeams()
            }
        },

        created () {
            this.getTeams()
        },

        methods: {
            getTeams() {
                this.loading = true
                axios.get('crm/teams/daily?date='+this.picker)
                    .then(response => {
                        this.loading = false
                        this.teams = response.data.teamlist
                        this.jobs = response.data.jobslist
                        this.phases = response.data.phaselist
                        this.$nextTick()
                    })
            },

            editItem (item) {
                this.editedIndex = this.teams.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (id) {
                this.editedIndex = id
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/team/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getPhases()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  this.errors.clear()
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                })
            },

            openCalendar(item) {
                this.$router.push('/team_calendar/' + item.id)
            },

            editPhase (item) {
                this.editedIndex = this.teams.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogPhase = true
            },

            closePhase () {
                this.dialogPhase = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/team/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTeams()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/team/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTeams()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },

            async savePhase () {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    axios.post('crm/team/job/update', {
                        id: this.editedItem.job.phase,
                        job_id: this.editedItem.job.id,
                        team_id: this.editedItem.id,
                        start_date: this.editedItem.job.start_date,
                        end_date: this.editedItem.job.end_date,
                        status: this.editedItem.job.status,
                    }).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.getTeams()
                        this.closePhase()
                    }).catch(error => {
                        console.log(error)
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },

            getCategory(id) {
              let categories = this.categories.filter(cat => {
                return cat.value == id
              })

              return categories[0].label
            },

            getPhaseTitle(item) {
                if(item.job) {
                  let phase = this.phases.filter(i => {
                    return i.id == item.job.phase
                  })

                  if(phase.length) 
                    return phase[0].title
                  else 
                    return ''
                }
            },
        },
    }
</script>

<style lang="sass">
.button-row 
    height: auto!important

thead
    &.v-data-table-header
        background: #2196F3

        th 
            span
                font-size: 16px
                color: #ffffff
                line-height: 1em

.dpick
  border-radius: 0!important

  .v-date-picker-table
    height: auto!important
</style>